import { ReactNode } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ContactsDrawerBase, type DrawerContact } from './contacts-drawer-base';
import { GroupRecipient } from './group-thread-title';

type GroupContactsDrawerProps = {
  open: boolean;
  onClose: () => void;
  recipients: GroupRecipient[];
  locationId?: string;
  onSelect?: (personId: string) => void;
  rightSlot?: ReactNode;
};

export const GroupContactsDrawer = ({
  open,
  onClose,
  recipients,
  locationId,
  onSelect,
  rightSlot,
}: GroupContactsDrawerProps) => {
  const { t } = useTranslation('thread-header');

  const contacts: DrawerContact[] = recipients.flatMap((recipient) => {
    const resolvedPersonId = recipient.personId ?? recipient.person?.personId;
    if (!resolvedPersonId) {
      return [];
    }

    return [
      {
        personId: resolvedPersonId,
        person: recipient.person,
        isPrimary: true,
      },
    ];
  });

  return (
    <ContactsDrawerBase
      contacts={contacts}
      title={t('Contacts In This Group')}
      subtitle={t('Select to focus another contact...')}
      count={recipients.length}
      open={open}
      onClose={onClose}
      onSelect={(personId) => {
        onSelect?.(personId);
      }}
      locationId={locationId ?? ''}
      rightSlot={rightSlot}
      variant='group'
    />
  );
};
